import { authController } from "@reedexpo/authorization-component-ui";

const authCookieName = "RX_AUTH";
const clientIdCookieName = "ClientId";

const getCookies = () => {
  const cookies = {};
  // eslint-disable-next-line no-undef
  document.cookie.split("; ").forEach((cookie) => {
    const [name, value] = cookie.split("=");
    cookies[name] = decodeURIComponent(value);
  });
  return cookies;
};

const usePcke = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return window && window.authSettings && window.authSettings.usePkce;
};

const getToken = async () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (usePcke()) {
    try {
      const t = await authController.getToken();
      return t;
    } catch (e) {
      return e;
    }
  }
  return Promise.resolve(getCookies()[authCookieName] || null);
};

const hasClaim = async (allowAdmins, claimName, claimValue) => {
  const token = await getToken();
  try {
    if (!token) return false;
    return await authController.hasClaim(allowAdmins, claimName, claimValue);
  } catch (e) {
    return false;
  }
};

const getClientId = () => getCookies()[clientIdCookieName] || null;

const getUserId = async () => {
  const token = await getToken();
  if (!token) {
    return null;
  }
  return token.trim() && JSON.parse(window.atob(token.split(".")[1])).sub;
};

export default {
  getToken,
  getClientId,
  getUserId,
  hasClaim,
};
